import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { inviteFormType } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import InviteUser from '../components/InviteUser';
import PromoterUserTable from './PromoterUserTable';
import { ListContainer } from 'components';

const PromoterUsers = () => {
    return (
        <ListContainer>
            <Routes>
                <Route
                    path="invite-promoter"
                    element={
                        <InviteUser
                            title={texts.PROMOTER_CREATE_USER}
                            type={inviteFormType.PROMOTER}
                        />
                    }
                />
                <Route index element={<PromoterUserTable />} />
                <Route path="*" element={<Navigate to="/promoter-users" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default PromoterUsers;
